import React, { Component } from 'react'
import grid from './grid.module.css'

class Clearfix extends Component {
   makeFullClasses() {
      const { className } = this.props

      let classes = []
      classes.push(grid.clearfix)

      if(className)
      classes.push(className)

      return classes.join(' ')
   }

   render() {
      return (
         <div className={this.makeFullClasses()} style={{ ...this.props.style }}>
            {this.props.children}
         </div>
      )
   }
}

export default Clearfix


// WEBPACK FOOTER //
// ./src/v2SPRINTA/atoms/Grid/Clearfix.js